import React, { useCallback, useState, useEffect } from 'react';
import {
    useNavigate
} from "react-router-dom";
import { getResponse } from '../../Utils/Helper';
import { useDropzone } from 'react-dropzone'
import NoresultImage from '../NoresultImage'
import Results from '../Results'
import { uploadViaPresignedUrl } from '../../Utils/Helper'
import Loader from '../../common/Loader';
import $ from 'jquery'

export default function UploadImage(props) {

    const [selectedFile, setSelectedFile] = useState([])
    const [pregress, setProgress] = useState(0)
    const [results, setResults] = useState([])
    const [isResult, setIsResult] = useState(false)
    const [preview, setPreview] = useState("")
    const [norecord, setNorecord] = useState(false)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const onDrop = useCallback(acceptedFiles => {
        console.log('accept ', acceptedFiles)
        if (acceptedFiles && acceptedFiles.length > 0) {
            
            setSelectedFile(acceptedFiles[0])
            const objectUrl = URL.createObjectURL(acceptedFiles[0])
            setPreview(objectUrl)
        }

    }, [])

    const handleUpload = async () => {
        $("#preloader_bg").show();
        let key;
        try {
            key = await uploadViaPresignedUrl(selectedFile);
        } catch (error) {
            $("#preloader_bg").hide();
            console.error("Upload failed:", error);
            alert("Upload failed: " + (error && error.message ? error.message : "unknown") + ". Please try again.");
            return;
        }

        // face Recognize api — find-faces on the uploaded key
        let data = {
            secretkey: "mnopqrstuvwxyz0123456789",
            accessToken: "XgaGEsmoZmLDtfbeqW+Ldw==",
            file: key
        };
        getResponse(data)
            .done((res) => {
                $("#preloader_bg").hide();
                if (res.resultFlag == 1 && res.response && res.response.FaceMatches && res.response.FaceMatches.length > 0) {
                    localStorage.setItem("listResult", JSON.stringify(res.response.FaceMatches))
                    localStorage.setItem("backurl", "/upload/image")
                    setIsResult(true)
                    setResults(res.response.FaceMatches)
                    navigate("/list" + window.location.search)
                } else {
                    setNorecord(true)
                    localStorage.setItem("listResult", [])
                    localStorage.setItem("backurl", "/upload/image")
                    setIsResult(false)
                    setResults([])
                }
            })
            .fail(() => {
                $("#preloader_bg").hide();
                alert("Something went wrong. Please try again.");
            });
    }

    const handleNoRecords = () => {
        setNorecord(false);
        setIsResult(false)
    }
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })
    return (
        <>
            <Loader />
            {!isResult && !norecord ?
                <>
                    <div className="container-fluid">
                        <div className="upload_imege_div">
                            <div className="uploadimage_div" {...getRootProps()}>
                                <input {...getInputProps()} accept="image/png, image/jpg, image/jpeg" />
                                <img src={preview ? preview : `/assets/images/folder.svg`} alt="" />
                            </div>
                            <h5>Drop image here, or browse</h5>
                            <h6>Supports: JPG, JPEG, PNG</h6>
                            <h6>Kindly upload a clear image of your face</h6>
                            {selectedFile && selectedFile.name &&
                                <>
                                    <div className="progress custom_progress">
                                        <div className="progress-bar custom_progress-bar" style={{ width: '70%' }}></div>
                                    </div>
                                    <div className="image_detail">
                                        <ul>
                                            <li>
                                                <p className="image_name">{selectedFile.name}</p>
                                            </li>
                                            <li>
                                                <p className="image_status" onClick={() => handleUpload()}>
                                                    <img src="/assets/images/file.svg" alt="" /> Upload
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                    {/* <div className="probox" id="progressBar">
                                    <div
                                        className="progessbox"
                                        style={{ width: "0%" }}
                                        data-dz-uploadprogress
                                    ></div>
                                </div>
                                <div>
                                    <span style={{ float: 'left' }}>{selectedFile.name}</span>
                                    <a style={{ float: 'right' }} href="#" onClick={() => handleUpload()} >Upload</a>
                                </div> */}
                                </>
                            }
                        </div>
                    </div>
                </>
                :
                (norecord ?
                    <NoresultImage handleNoRecords={handleNoRecords} />
                    :
                    <Results preview={preview} filename={selectedFile.name} results={results} />
                )
            }

        </>
    )
}